import { render, staticRenderFns } from "./schoolRank.vue?vue&type=template&id=275e4ffa&scoped=true&"
import script from "./schoolRank.vue?vue&type=script&lang=js&"
export * from "./schoolRank.vue?vue&type=script&lang=js&"
import style0 from "./schoolRank.vue?vue&type=style&index=0&id=275e4ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e4ffa",
  null
  
)

export default component.exports